import { render, staticRenderFns } from "./AdminCompanies.vue?vue&type=template&id=ecd9c37e&"
import script from "./AdminCompanies.vue?vue&type=script&lang=js&"
export * from "./AdminCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports